// default parallax is 0.12
const quoteDefinitions = [
  {
    page: '1',
    tone: 'light',
    bottom: '15%',
    lines: [
      { size: 'small', text: 'This film is for all the', quotationMarks: 'start', },
      { size: 'medium', text: 'unfinished loves and all\nthe unfinished lives', mobileText: 'unfinished loves\nand all the\nunfinished lives' },
      { size: 'small', text: 'of our community.', quotationMarks: 'end', },
      { size: 'attribution', text: 'Javier Ambrossi\nCo-Director', },
    ],
    mobile: {
      top: '35%',
      left: '15%',
      width: '80%',
    },
  },
  {
    page: '3',
    tone: 'dark',
    color: '#000000',
    top: '10%',
    left: '25%',
    width: '45%',
    lines: [
      { size: 'small', text: 'I remember the first lunch', quotationMarks: 'start', },
      { size: 'medium', text: 'where they told us\nabout this movie.',   },
      { size: 'small', text: 'we just sat there listening\nwhile they described this\nentire world.' },
    ],
    parallax: 0,
    mobile: {
      top: '20%',
      left: '12%',
      width: '95%',
      parallax: 0.12,
    },
    
  },
  {
    page: '3',
    tone: 'dark',
    color: '#000000',
    bottom: '5%',
    left: '60%',
    width: '30%',
    lines: [
      {
        size: 'small',
        text: 'When we left that lunch, we were\nas excited as they were.',
        mobileText: 'When we left that lunch, we\nwere as excited as they were.',
      },
      {
        size: 'medium',
        text: 'They generate energy.',
        mobileText: 'They generate\nenergy.',
      },
      {
        size: 'small',
        text: 'And you leave feeling the\nvertigo of something incredibly\npowerful that they’ve just\ntransmitted to you.',
        quotationMarks: 'end',
      },
      { size: 'attribution', text: 'Javier Ambrossi\nCo-Director' },
    ],
    mobile: {
      bottom: '10%',
      left: '12%',
      width: '90%',
    },
  },
  {
    page: '4',
    tone: 'dark',
    color: '#000000',
    top: '10%',
    left: '20%',
    width: '40%',
    lines: [
      { size: 'large', text: 'We’ve worked with\nthe same people\nfor years.', quotationMarks: 'start' },
      { size: 'small', text: 'They’re not just collaborators.' },
    ],
    mobile: {
      top: '7%',
      left: '15%',
      width: '90%',
      parallax: 0,
    }
  },
  {
    page: '5',
    tone: 'dark',
    color: '#000000',
    bottom: '15%',
    left: '7%',
    width: '30%',
    lines: [
      { size: 'large', text: 'They’re friends.' },
      { size: 'small', text: 'that creates something real\nand truthful to us.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Javier Calvo\nCo-Director' },
    ],
    mobile: {
      top: '13%',
      left: '5%',
      width: '80%',
    }
  },
  {
    page: '5',
    tone: 'dark',
    color: '#000000',
    top: '10%',
    left: '70%',
    width: '35%',
    lines: [
      { size: 'small', text: 'This movie is not about one craft.\nIt\'s about all of the different\ndepartments like music,\ncostumes, cinematography,\nproduction design, music, sound,\nhair and makeup', mobileText: 'This movie is not about one\ncraft. It\'s about all of the\ndifferent departments like\nmusic, costumes,\ncinematography, production\ndesign, music, sound, hair\nand makeup' },
      { size: 'medium', text: 'all coming together\nto create art.', mobileText: 'all coming\ntogether\nto create art.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Alberto Gutiérrez\nEditor' },
    ],
    mobile: {
      bottom: '10%',
      left: '12%',
      width: '90%',
    }
  },
  {
    page: '7',
    tone: 'dark',
    color: '#000000',
    bottom: '10%',
    left: '25%',
    width: '80%',
    lines: [
      { size: 'small', text: 'It\'s impossible to work without\nall of the crafts departments\nbeing united. You\'re constantly', mobileText: 'It\'s impossible to work\nwithout all of the crafts\ndepartments being united.\nYou\'re constantly', quotationMarks: 'start' },
      { size: 'medium', text: 'collaborating and\nmaking those decisions\ntogether.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Mariló Osuna\nMakeup Designer' },
    ],
    mobile: {
      top: '15%',
      left: '15%',
      width: '80%',
    }
  },
  {
    page: '8',
    tone: 'light',
    bottom: '10%',
    left: '50%',
    width: '50%',
    lines: [
      { size: 'large', text: 'We are friends\nenjoying the\nother friend’s\ntalent.', quotationMarks: 'start' },
    ],
    mobile: {
      page: '9',
      top: '10%',
      left: '25%',
      width: '90%',
    }
  },
  {
    page: '9',
    tone: 'light',
    top: '30%',
    left: '20%',
    width: '50%',
    lines: [
      { size: 'small', text: 'that’s the trust where you\ncan take a leap of faith...' },
      { size: 'medium', text: 'That’s why it\nworks.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Roger Bellés\nProduction Designer' },
    ],
    mobile: {
      bottom: '15%',
      left: '12%',
      width: '90%',
    }
  },
  {
    page: '11',
    tone: 'dark',
    top: '15%',
    left: '12%',
    width: '50%',
    lines: [
      { size: 'small', text: 'When I read the story,', mobileText: 'When I read\nthe story,', quotationMarks: 'start' },
      { size: 'medium', text: 'I\'m not thinking in light,', mobileText: 'I\'m not\nthinking\nin light,' },
      { size: 'small', text: 'I\'m thinking how, with my camera,', mobileText: 'I\'m thinking how,\nwith my camera,' },
    ],
    mobile: {
      top: '7%',
      left: '50%',
      width: '50%',
    }
  },
  {
    page: '11',
    tone: 'dark',
    bottom: '15%',
    left: '60%',
    width: '50%',
    lines: [
      { size: 'medium', text: 'can I enhance\nthis emotion' },
      { size: 'small', text: 'that the character is feeling\nand how it will connect to the\nrhythm in the editing.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Gris Jordana\nCinematographer' },
    ],
    mobile: {
      bottom: '15%',
      left: '8%',
      width: '90%',
    }
  },
  {
    page: '12',
    tone: 'light',
    bottom: '10%',
    left: '10%',
    width: '40%',
    parallax: '0',
    lines: [
      { size: 'small', text: 'our format, it\'s', quotationMarks: 'start' },
      { size: 'medium', text: '35 millimeters' },
      { size: 'small', text: 'and it has these round corners.\nIt\'s not a format that is square or\nthat is panoramic, it\'s in between\nand that makes it very special.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Gris Jordana\nCinematographer' },
    ],
    mobile: {
      page: '13',
      top: '10%',
      left: '15%',
      width: '90%',
      tone: 'dark'
    }
  },
  {
    page: '13',
    tone: 'dark',
    top: '40%',
    left: '30%',
    width: '60%',
    lines: [
      { size: 'small', text: 'We worked with a\nchoreographer who helped us,\nmove the crowd in a sort of\ncontemporary dance that you\n can\'t tell (is a dance). The actors\nplaying soldiers learned how to\nwalk and to load their guns with\na colonel, but also with the\nchoreographer', mobileText: 'We worked with a\nchoreographer who helped\nus, move the crowd in a sort of\ncontemporary dance that you\n can\'t tell (is a dance). The\nactors playing soldiers\nlearned how to walk and to\nload their guns with a colonel,\nbut also with the\nchoreographer', quotationMarks: 'start' },
    ],
    mobile: {
      top: '40%',
      left: '15%',
      width: '80%',
    }
  },
  {
    page: '14',
    tone: 'light',
    bottom: '10%',
    right: '5%',
    width: '40%',
    lines: [
      { size: 'small', text: 'It was like a mix of contemporary\ndance and military training'},
      { size: 'medium', text: 'because we wanted\nto make visual\npoetry.', mobileText: 'because we\nwanted to make\nvisual poetry.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Javier Calvo\nCo-Director' }
    ],
    mobile: {
      standalone: true,
      tone: 'dark',
      top: '20%',
      left: '8%',
      width: '90%',
    }
  },
  {
    page: '15',
    tone: 'light',
    top: '10%',
    left: '15%',
    width: '40%',
    lines: [
      { size: 'small', text: 'I tried with', quotationMarks: 'start'},
      { size: 'medium', text: 'color and\ntextures' },
      { size: 'small', text: 'to explain how these\ncharacters were feeling.' }
    ],
    mobile: {
      top: '5%',
      left: '12%',
      width: '80%',
    }
  },
  {
    page: '16',
    tone: 'dark',
    top: '25%',
    left: '30%',
    width: '50%',
    lines: [
      { size: 'small', text: 'For example, in the 1932 timeline, I\ndecided to use black and white\nfor all the images that were shot\ninside of Carlos\' house and inside\nof the casino. It\'s not very\nobvious, but if you look at it, you\nsee that it\'s always dark and\nreally light colors for them. He\ngoes into the casino for the first\ntime wearing a white suit because\nhe still has hope, and he feels\nthat he\'s going to get the chance.\nFrom that point on, his costumes\nstop turning darker.', mobileText: 'For example, in the 1932 timeline, I\ndecided to use black and white for\nall the images that were shot inside\nof Carlos\' house and inside of the\ncasino. It\'s not very obvious, but if\nyou look at it, you see that it\'s always\ndark and really light colors for\nthem. He goes into the casino for the\nfirst time wearing a white suit\nbecause he still has hope, and he\nfeels that he\'s going to get the\nchance. From that point on, his\ncostumes stop turning darker.', quotationMarks: 'end'},
      { size: 'attribution', text: 'Ana López Cobos\nCostume Designer' }
    ],
    mobile: {
      top: '35%',
      left: '8%',
      width: '95%',
    }
  },
  {
    page: '17',
    tone: 'dark',
    top: '20%',
    left: '30%',
    width: '50%',
    lines: [
      { size: 'small', text: 'For the world we were', quotationMarks: 'start'},
      { size: 'medium', text: 'building for 1932,', mobileText: 'building\nfor 1932,' },
      { size: 'small', text: 'it was a little bit theatrical because\nit’s the point of the movie\nwhere you now understand that\nyou are inside of a play, so we\ncould make the peak of fantasy.', mobileText: 'it was a little bit theatrical\nbecause it’s the point of the\nmovie where you now\nunderstand that you are\ninside of a play, so we could\nmake the peak of fantasy.' }
    ],
    mobile: {
      top: '15%',
      left: '15%',
      width: '80%',
    }
  },
  {
    page: '19',
    tone: 'dark',
    top: '20%',
    left: '15%',
    width: '50%',
    lines: [
      { size: 'small', text: 'We built the casino, but not at a studio; not\non a soundstage. We built a building, but', mobileText: 'We built the casino, but not at a\nstudio; not on a soundstage.\nWe built a building, but' },
      { size: 'medium', text: 'to make it real, we set it\nin a real landscape.', mobileText: 'to make it real,\nwe set it in a\nreal landscape.' },
      { size: 'small', text: 'When you open the windows of this set,\nyou will see Spain.', mobileText: 'When you open the windows of this set, you will see Spain.' }
    ],
    mobile: {
      top: '18%',
      left: '5%',
      width: '80%',
    }
  },
  {
    page: '20',
    tone: 'light',
    bottom: '10%',
    right: '15%',
    width: '40%',
    lines: [
      { size: 'small', text: 'It makes everything 10 times\nmore complicated than building\na set on a soundstage because\nwe have to control the natural\nlighting, we have to control the\nclimate - but it has a lot of truth.', mobileText: 'It makes everything 10 times more\ncomplicated than building a set on\na soundstage because we have to\ncontrol the natural lighting, we\nhave to control the climate - but it\nhas a lot of truth.' },
      { size: 'large', text: 'That’s the magic\nof this set.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Roger Bellés\nProduction Designer' }
    ],
    mobile: {
      page: '19',
      tone: 'dark',
      bottom: '9%',
      left: '5%',
      width: '90%',
    }
  },
  {
    page: '22',
    tone: 'dark',
    top: '25%',
    left: '35%',
    width: '50%',
    lines: [
      { size: 'small', text: 'You have all the layers,\nmixing history and memory\nand tension. It’s a dialogue\nbetween what you\nremember and what was,\nand what you inherit,', mobileText: 'You have all the layers, mixing\nhistory and memory and tension.\nIt’s a dialogue between what you\nremember and what was, and what\nyou inherit,', quotationMarks: 'start' },
      { size: 'large', text: 'What happens\nwith memory.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Roger Bellés\nProduction Designer' }
    ],
    mobile: {
      bottom: '20%',
      left: '12%',
      width: '90%',
    }
  },
  {
    page: '23',
    tone: 'light',
    top: '12%',
    left: '5%',
    width: '40%',
    parallax: 0,
    lines: [
      { size: 'small', text: 'We found that\nthe rhythm of\nthe movie was\nnot about going\nfaster.', quotationMarks: 'start' },
    ]
  },
  {
    page: '23',
    tone: 'light',
    top: '12%',
    left: '34%',
    width: '40%',
    parallax: 0,    
    lines: [
      { size: 'small', text: 'Sometimes the\nemotional thing\nabout the movie is to' },
    ]
  },
  {
    page: '23',
    tone: 'light',
    top: '12%',
    left: '50%',
    width: '40%',
    parallax: 0,
    lines: [
      { size: 'large', text: 'stay with\nsomebody.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Alberto Gutiérrez\nEditor' }
    ]
  },
  {
    page: '24',
    tone: 'dark',
    top: '30%',
    left: '25%',
    width: '50%',
    lines: [
      { size: 'small', text: 'As the three stories start to mix\ntogether and you start to\nunderstand that it\'s not three\ndifferent stories, but it\'s one\nstory that that they\'re\nexplaining from different points\nof view. Then the music, the\ndifferent timbres are starting\nto mix together. And when you\narrive to the last part of the\nfilm, to the last scene,', quotationMarks: 'start' },
    ],
    mobile: {
      top: '25%',
      left: '12%',
      width: '80%',
    }
  },
  {
    page: '25',
    tone: 'light',
    bottom: '15%',
    right: '5%',
    width: '50%',
    lines: [
      { size: 'small', text: 'you understand the whole\norchestra is playing\ntogether because' },
      { size: 'large', text: 'the three stories\nare mixed together', mobileText: 'the three\nstories are\nmixed together' },
      { size: 'small', text: 'in that moment.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Raül Refree\nOriginal Music' }
    ],
    mobile: {
      standalone: true,
      page: '25',
      standaloneHeight: '760px',
      tone: 'dark',
      top: '32%',
      left: '5%',
      width: '90%',
    }
  },
  {
    page: '26',
    tone: 'dark',
    top: '26%',
    left: '15%',
    width: '50%',
    lines: [
      { size: 'small', text: 'I don\'t want you to see the\nmakeup. I want you to see', quotationMarks: 'start' },
      { size: 'large', text: 'the character.' },
      { size: 'small', text: 'for me, makeup is a\nnarrative tool', quotationMarks: 'end' },
      { size: 'attribution', text: 'Mariló Osuna,\nMakeup Designer' }
    ],
    mobile: {
      standalone: true,
      page: '25',
      standaloneHeight: '760px',
      top: '70%',
      left: '25%',
      width: '70%',
    }
  },
  {
    page: '28',
    tone: 'dark',
    bottom: '15%',
    left: '40%',
    width: '50%',
    lines: [
      { size: 'small', text: 'Because there are three different\nperiods, they needed to feel\ndistinct from one another, but\nthere also needed to be a\nconnection between them. We had\nto look at who these people were,\nwhat their personalities were,\nwhere they came from, how they\nhad arrived at this point, and\neverything they were carrying\nwith them emotionally.', mobileText: 'Because there are three\ndifferent periods, they needed\nto feel distinct from one\nanother, but there also needed\nto be a connection between\nthem. We had to look at who\nthese people were, what their\npersonalities were, where they\ncame from, how they had\narrived at this point, and\neverything they were carrying\nwith them emotionally.', quotationMarks: 'both' },
      { size: 'attribution', text: 'Mariló Osuna,\nMakeup Designer' }
    ],
    mobile: {
      top: '50%',
      left: '15%',
      width: '80%',
    }
  },
  {
    page: '30',
    tone: 'light',
    top: '15%',
    left: '50%',
    width: '40%',
    lines: [
      { size: 'small', text: 'You\'re not just\nlooking for the', quotationMarks: 'start' },
      { size: 'large', text: 'best actor\nfor a role,' },
      { size: 'small', text: 'but the one who is\ngoing to understand it in a deeper level.', quotationMarks: 'end' },
    ],
    mobile: {
      top: '15%',
      left: '40%',
      width: '55%',
    }
  },
  {
    page: '32',
    tone: 'dark',
    bottom: '15%',
    left: '30%',
    width: '40%',
    lines: [
      { size: 'small', text: 'So we try to find the\ncharacter in each actor, and\nwe wait for that cathartic\nmoment when the actor just\nsnaps and connects with the\nfeeling of the character,', mobileText: 'So we try to find the character in\neach actor, and we wait for that\ncathartic moment when the actor\njust snaps and connects with the\nfeeling of the character.', quotationMarks: 'start' },
      { size: 'large', text: 'and they\'re\nthe same.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Javier Calvo\nCo-Director' },
    ],
    mobile: {
      top: '35%',
      left: '12%',
      width: '80%',
    },
  },
  {
    page: '34',
    tone: 'dark',
    top: '15%',
    left: '15%',
    width: '50%',
    lines: [
      { size: 'small', text: 'We kept taking lines out of the text\nand letting things remain unspoken,\nletting them be told through', mobileText: 'We kept taking lines out of the\ntext and letting things remain\nunspoken, letting them be told through', quotationMarks: 'start' },
      { size: 'large', text: 'the eyes of Sebastián\nand Rafael.', mobileText: 'the eyes of\nSebastián and\nRafael.', quotationMarks: 'end' },
      { size: 'attribution', text: 'Javier Calvo\nCo-Director' },
    ],
    mobile: {
      bottom: '15%',
      left: '12%',
      width: '90%',
    },
  },
  {
    page: '35',
    tone: 'dark',
    top: '20%',
    left: '20%',
    width: '70%',
    lines: [
      { size: 'small-bold', text: 'The Beloved Sleeps on\nthe Breast of the Poet' },
      { size: 'smaller', text: 'You will never know how much I love you\nFor you sleep within me and are asleep.\nI hide you, in tears, persecuted…\nBy a voice of penetrating steel.' },
      { size: 'smaller', text: 'The law that stirs\nBoth flesh and star\nNow pierces my aching breast\nAnd dark wings bite\nInto the wings of your guarded spirit.' },
      { size: 'attribution', text: 'Federico Garcia Lorca' },
    ],
    mobile: {
      top: '15%',
      left: '7%',
      width: '90%',
    },
  },
  {
    page: '36',
    tone: 'dark',
    bottom: '15%',
    left: '25%',
    width: '70%',
    lines: [
      { size: 'small', text: 'There’s a moment in the film where\nSebastián reads a poem and says,', quotationMarks: 'start' },
      { size: 'large', text: '‘I don’t understand it.’' },
      { size: 'small', text: 'But by the end, after experiencing love,\nloss, and Spain itself, he finally\nunderstands the words', quotationMarks: 'end' },
      { size: 'attribution', text: 'Javier Ambrossi\nCo-Director' },
    ],
    mobile: {
      top: '40%',
      left: '12%',
      width: '80%',
    },
  },
  {
    page: '37',
    tone: 'dark',
    top: '12%',
    left: '20%',
    width: '60%',
    parallax: 0,
    lines: [
      { size: 'title', text: 'What if?' },
      { size: 'paragraph', text: 'We began the journey to create our film LA BOLA NEGRA by reading Alberto Conejero’s play La piedra oscura. The play was centered on one of the three storylines in our film, and it led us down a rabbit hole of exploration. Self-exploration, exploration into the history of our beloved Spain, and exploration of poet Federico García Lorca. La bola negra is the unfinished play Lorca was writing when he was tragically murdered. Four pages exist. Those four pages are filled with possibility. That was the spark that ignited our imaginations and passion to create this film. What if he had been able to finish his play? What if we don’t know everything about our forebears and grandfathers? What if we could honor and link queer history across generations?' },
      { size: 'paragraph', text: 'We wanted to create a sweeping romance that asks the question: What do we do with our past, with our inheritance, with the objects and art that remain, with the traces history leaves behind? We wanted to make that heritage accessible, to transform it into something emotionally immediate. We believe art can act as a bridge between generations. In that spirit, we made this film with our friends and family — collaborators we’ve worked with since the beginning of our careers. We are so incredibly grateful to our filmmaking family. Working with Guitarricadelafuente in his acting debut was a journey of profound discovery. Having our muses and legends Penélope Cruz and Glenn Close grace our film with their talents was everything we dreamed of. Every actor, every crew member, every extra brought themselves fully to this production.' },
      { size: 'paragraph', text: 'LA BOLA NEGRA is filmed in 35mm not only because we love its aesthetics or because we wanted the challenge, but because film is alive. We wanted to create an object that’s going to exist forever, something you can really touch, just like those four pages.' },
      { size: 'paragraph', text: 'We also honor our spiritual and cinematic heroes in the making of this film. Filmmakers like Pedro Almodóvar, Béla Tarr, Elem Klimov, Alice Rohrwacher, John Cameron Mitchell, Andrei Tarkovsky, Francis Ford Coppola… the list goes on and on.' },
      { size: 'paragraph', text: 'This film is about the fantasy of possibility, of what we carry forward, and what we leave behind. We invite you to open your hearts, to feel deeply, to look at your living and past relatives with compassion, and more than anything — we hope you enjoy the film.' },
      { size: 'paragraph', text: 'With love,\nJavier Ambrossi and Javier Calvo' },
    ],
    mobile: {
      top: '10%',
      left: '5%',
      width: '90%',
    },
  },
];

export default quoteDefinitions;